<div class="modal-header">
  <div class="d-flex flex-column">
    <h4 class="modal-title mb-1">
      <i class="fa fa-user-edit text-primary me-2"></i>
      {{ 'companyProfile.membershipPlans.editMember.title' | translate }}
    </h4>
    <p class="text-muted small mb-0">{{ getMemberName() }}</p>
  </div>
  <button type="button" class="btn-close" [attr.aria-label]="'common.close' | translate" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <!-- Error Message -->
  @if (errorMessage) {
    <div class="alert alert-danger mb-4">
      <i class="fa fa-exclamation-triangle me-2"></i>
      {{ errorMessage }}
    </div>
  }

  <!-- Manual Member Info (editable) -->
  @if (isManualMember) {
    <h6 class="mb-4">
      <i class="fa fa-user text-muted me-2"></i>
      {{ 'companyProfile.membershipPlans.editMember.memberInfo' | translate }}
    </h6>
    <div class="row g-3 mb-4">
      <div class="col-6">
        <label class="form-label">{{ 'companyProfile.membershipPlans.addMember.firstName' | translate }} <span class="text-danger">*</span></label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="firstName"
          [placeholder]="'companyProfile.membershipPlans.addMember.firstNamePlaceholder' | translate"
        />
      </div>
      <div class="col-6">
        <label class="form-label">{{ 'companyProfile.membershipPlans.addMember.lastName' | translate }} <span class="text-danger">*</span></label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="lastName"
          [placeholder]="'companyProfile.membershipPlans.addMember.lastNamePlaceholder' | translate"
        />
      </div>
      <div class="col-6">
        <label class="form-label">{{ 'companyProfile.membershipPlans.addMember.email' | translate }}</label>
        <input
          type="email"
          class="form-control"
          [(ngModel)]="email"
          [placeholder]="'companyProfile.membershipPlans.addMember.emailPlaceholder' | translate"
        />
      </div>
      <div class="col-6">
        <label class="form-label">{{ 'companyProfile.membershipPlans.addMember.phone' | translate }}</label>
        <input
          type="tel"
          class="form-control"
          [(ngModel)]="phone"
          [placeholder]="'companyProfile.membershipPlans.addMember.phonePlaceholder' | translate"
        />
      </div>
    </div>
    <hr class="my-4"/>
  }

  <!-- Membership Status -->
  <h6 class="mb-4">
    <i class="fa fa-id-card text-muted me-2"></i>
    {{ 'companyProfile.membershipPlans.editMember.membershipStatus' | translate }}
  </h6>
  <div class="row g-3 mb-4">
    <div class="col-6">
      <label class="form-label">{{ 'companyProfile.membershipPlans.viewMembers.status' | translate }}</label>
      <select class="form-select" [(ngModel)]="status">
        <option value="active">{{ 'companyProfile.membershipPlans.viewMembers.active' | translate }}</option>
        <option value="pending">{{ 'companyProfile.membershipPlans.viewMembers.pending' | translate }}</option>
        <option value="expired">{{ 'companyProfile.membershipPlans.viewMembers.expired' | translate }}</option>
        <option value="cancelled">{{ 'companyProfile.membershipPlans.viewMembers.cancelled' | translate }}</option>
      </select>
    </div>
    <div class="col-6">
      <label class="form-label">{{ 'companyProfile.membershipPlans.addMember.expiresAt' | translate }}</label>
      <input
        type="date"
        class="form-control"
        [(ngModel)]="expiresAt"
      />
    </div>
  </div>

  <hr class="my-4"/>

  <!-- Payment Information -->
  <h6 class="mb-4">
    <i class="fa fa-credit-card text-muted me-2"></i>
    {{ 'companyProfile.membershipPlans.addMember.paymentInfo' | translate }}
  </h6>
  <div class="row g-3 mb-4">
    <div class="col-6">
      <label class="form-label">{{ 'companyProfile.membershipPlans.addMember.paymentStatus' | translate }}</label>
      <select class="form-select" [(ngModel)]="paymentStatus">
        <option value="paid">{{ 'companyProfile.membershipPlans.addMember.paid' | translate }}</option>
        <option value="pending">{{ 'companyProfile.membershipPlans.addMember.pending' | translate }}</option>
        <option value="not_required">{{ 'companyProfile.membershipPlans.addMember.notRequired' | translate }}</option>
      </select>
    </div>
    <div class="col-6">
      <label class="form-label">{{ 'companyProfile.membershipPlans.addMember.paymentMethod' | translate }}</label>
      <select class="form-select" [(ngModel)]="paymentMethod">
        <option value="manual">{{ 'companyProfile.membershipPlans.addMember.methodManual' | translate }}</option>
        <option value="bank_transfer">{{ 'companyProfile.membershipPlans.addMember.methodBankTransfer' | translate }}</option>
        <option value="cash">{{ 'companyProfile.membershipPlans.addMember.methodCash' | translate }}</option>
        <option value="stripe">{{ 'companyProfile.membershipPlans.addMember.methodStripe' | translate }}</option>
      </select>
    </div>
    <div class="col-12">
      <label class="form-label">{{ 'companyProfile.membershipPlans.addMember.paymentNote' | translate }}</label>
      <textarea
        class="form-control"
        [(ngModel)]="paymentNote"
        rows="2"
        [placeholder]="'companyProfile.membershipPlans.addMember.paymentNotePlaceholder' | translate"
      ></textarea>
    </div>
  </div>
</div>

<div class="modal-footer">
  <app-button
    [variant]="'ghost'"
    [label]="'common.cancel' | translate"
    (clicked)="activeModal.dismiss()"
  />
  <app-button
    [variant]="'primary'"
    [label]="isSubmitting ? ('common.saving' | translate) : ('common.save' | translate)"
    [iconClass]="isSubmitting ? 'fa fa-spinner fa-spin' : 'fa fa-check'"
    [disabled]="isSubmitting"
    (clicked)="submit()"
  />
</div>
